// extracted by mini-css-extract-plugin
export default {"pattern-gradient":"CategoryModal_pattern-gradient__23yIK","data":"CategoryModal_data__BpTVY"};